// The flight strip: the main list item on every page. Modeled on an ATC paper strip.
import type { Contact } from "../../shared/network";
import { CADENCE } from "../../shared/engine";
import { h, type Child } from "./dom";
import { iata } from "./iata";
import { ticks } from "./widgets";

export type StripTone = "green" | "amber" | "red" | "dim" | "cyan";
export interface StripLine {
  tone: StripTone;
  text: string;
  html?: Node; // optional richer content
}
export interface StripOpts {
  c: Contact;
  daysSince: number | null;
  bar: "amber" | "red" | "green" | "cyan" | "none";
  lines: StripLine[];
  keys: Node[];
  selected?: boolean;
  onSelect?: () => void;
  extra?: Node | null;
  id?: string;
}

export function splitName(n: string): { first: string; last: string } {
  const parts = (n || "").trim().split(/\s+/);
  if (parts.length < 2) return { first: "", last: parts[0] ?? "" };
  return { first: parts.slice(0, -1).join(" "), last: parts[parts.length - 1] };
}

export const peopleHref = (k: string): string => "#/people/" + encodeURIComponent(k);

export function strip(o: StripOpts): HTMLElement {
  const { c } = o;
  const nm = splitName(c.n);
  const loc = iata(c.ci, c.st);
  const cad = CADENCE[c.rs] ?? 0;
  const root = h("div", { class: "sw-wrap" + (o.selected ? " sel" : ""), "data-k": c.k });
  const link = h("a", { href: peopleHref(c.k), title: "Open " + c.n }, nm.last || c.n);
  const row = h(
    "div",
    { class: "strip" },
    h("div", { class: "sb " + (o.bar === "none" ? "" : o.bar) }),
    h("div", { class: "cs" }, h("div", { class: "ln" }, link), h("div", { class: "fn" }, nm.first || " "), h("div", { class: "co", title: c.co }, c.co || " ")),
    h("div", { class: "lc" }, h("div", { class: "code" }, loc.code), h("div", { class: "where", title: loc.label }, loc.label)),
    h("div", { class: "st" }, h("div", { class: "micro" }, "STR"), ticks(c.rs)),
    h(
      "div",
      { class: "ls" },
      h("div", { class: "big" }, h("span", { class: "micro" }, "LAST "), h("b", null, o.daysSince == null ? "—" : o.daysSince + "D")),
      h("div", { class: "cad" }, cad && cad < 100000 ? "/" + cad : "/—"),
    ),
    h("div", { class: "tx" }, o.lines.map((l) => h("div", { class: "l " + l.tone }, (l.html as Child) ?? l.text))),
    h("div", { class: "ky" }, o.keys),
  );
  root.appendChild(row);
  if (o.extra) root.appendChild(o.extra);
  if (o.onSelect) {
    row.addEventListener("click", (e) => {
      if ((e.target as HTMLElement).closest("button, a, input, textarea, select, label")) return;
      o.onSelect!();
    });
  }
  return root;
}
